/**
 * Serialized Each — client import saved-filter constants (#854, import-saved-filter WORKING-DOC).
 *
 * Mirrors the server-side `serializedEachConstants.js`. Kept client-local because the client rule
 * layer does not import server modules.
 */

// Personal saved-filter title, e.g. `IMPORT: Serialization - 1` (playback slide 31).
export const SAVED_FILTER_TITLE_PREFIX = 'IMPORT: ';

// The property every auto-serialized item is stamped with (#853, base-server upsert). The hidden
// report search element filters on this, and the saved filter's `filters` value targets it.
export const IMPORT_PROPERTY = 'meta.import';

// Serialized Each bulk imports POST to a virtual transaction relation: the model+quantity path to
// `transaction:itemsByModel` (`willImport_transaction_itemsByModel.js`) and the "Import from RFID Tags"
// path to `transaction:itemByTagId` (`willImport_transaction_itemByTagId.js`). Both stamp their items
// with `meta.import`, so both should get the personal saved filter — key on either relation. (Individual
// POSTs — "Create With Auto Serialization" / "Create From RFID Tag" — aren't imports, so never reach here.)
export const SE_IMPORT_FOREIGN_NAMESPACE = 'transaction';
export const SE_IMPORT_FOREIGN_RELATIONS = ['itemsByModel', 'itemByTagId'];

export default {
    SAVED_FILTER_TITLE_PREFIX,
    IMPORT_PROPERTY,
    SE_IMPORT_FOREIGN_NAMESPACE,
    SE_IMPORT_FOREIGN_RELATIONS
};
